export function isValidAdDestination(url) {
  const u = String(url ?? '').trim();
  if (!u || u === '#') return false;
  return /^https?:\/\//i.test(u);
}
